import { Image, Skeleton } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import avatar from "../../../../assets/img/avatar.png";
import ImageUpload from "../../../cleaner/components/ImageUpload";

function CustomerAvatar({ imageUrl, isEdit = false, loading = false, fileList, onFileChange }) {
    const { t } = useTranslation("customers");

    if (loading) {
        return (
            <div className="flex justify-center border-b border-[#f0f0f0] px-4 py-6">
                <Skeleton.Avatar active size={120} />
            </div>
        );
    }

    if (isEdit) {
        return (
            <div className="flex flex-col items-center border-b border-[#f0f0f0] px-4 py-6">
                <ImageUpload
                    maxCount={1}
                    handleFileChange={onFileChange}
                    fileList={fileList}
                    listType="picture-circle"
                />
                <p className="mt-2 text-xs text-[#acacb9]">{t("customerDetail.uploadImage")}</p>
            </div>
        );
    }

    return (
        <div className="flex justify-center border-b border-[#f0f0f0] px-4 py-6">
            <Image
                src={imageUrl || avatar}
                alt=""
                className="!h-[7.5rem] !w-[7.5rem] rounded-full object-cover shadow-[0_4rem_2rem_-3.4rem_#5d5dff]"
                preview={imageUrl ? { mask: t("view") } : false}
            />
        </div>
    );
}

CustomerAvatar.propTypes = {
    imageUrl: PropTypes.string,
    isEdit: PropTypes.bool,
    loading: PropTypes.bool,
    fileList: PropTypes.array,
    onFileChange: PropTypes.func,
};

export default CustomerAvatar;
